var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bankari-app-root"
  }, [_vm.showWorkspaces ? _c('workspace-tabs', {
    attrs: {
      "user": _vm.me
    },
    on: {
      "session-ended": _vm.endSession
    }
  }) : _c('router-view', {
    staticStyle: {
      "height": "100%"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }